import { Animated, Image, Pressable, StyleSheet, Text, TouchableOpacity, View } from "react-native";
import React, { useRef, useState } from "react";
import { fp, hp, spH, spV, wp } from "utils/normalise";
import { router, useLocalSearchParams } from "expo-router";

import { ANALYTICS_EVENT_NAMES } from "utils/analytics";
import { Colors } from "colors";
import Heading from "components/Heading";
import ImageView from "../../../src/image";

import { Images } from "assets";
import VText from "components/VText";
import { trackV2 } from "utils/Segment";
import { useSelector } from "react-redux";

const ShopByCategories = (data) => {
    const homeCategories = useSelector((state) => state.HomeReducer.homeCategories) || [];
    const [currentIndex, setCurrentIndex] = useState(0);
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const local = useLocalSearchParams();
    const gender = local?.gender ?? "female";

    const handleScroll = (direction) => {
        const step = 3; // Number of items to scroll
        if (direction === "left") {
            setCurrentIndex((prevIndex) => Math.max(0, prevIndex - step));
        } else {
            setCurrentIndex((prevIndex) => Math.min(homeCategories.length - step, prevIndex + step));
        }
    };
    return (
        <View style={styles.container}>
            <Heading type="h1" style={styles.headingText}>
                Shop by Category
            </Heading>
            {/* <VText style={styles.headingText}>Shop by Category</VText> */}
            <View style={{ flexDirection: "row" }}>
                {Array.isArray(homeCategories) &&
                    homeCategories?.slice(currentIndex, currentIndex + 3).map((category, index) => (
                        <Pressable
                            key={index}
                            activeOpacity={1}
                            onPress={() => {
                                const eventData = {
                                    current_section: gender === "female" ? "Women" : "Men",
                                    category_name: category?.categoryName,
                                };
                                trackV2(ANALYTICS_EVENT_NAMES.CATEGORY_CLICKED, eventData);
                                if (category?.categoryName == "Designers") {
                                    router.push(`/designers?gender=${gender}`);
                                } else if (category.categoryName == "Clothing") {
                                    router.push(`/shop/clothing?page=1&title=Clothing&gender=${gender}`);
                                } else if (category.categoryName == "Shoes") {
                                    router.push(`/shop/shoes?page=1&title=Shoes&gender=${gender}`);
                                } else if (category.categoryName == "Bags") {
                                    router.push(`/shop/bags?page=1&title=Bags&gender=${gender}`);
                                } else if (category.categoryName == "Jewelry & Watches") {
                                    router.push(
                                        `/shop/jewelry-&-watches?page=1&title=Jewelry %26 Watches&gender=${gender}`
                                    );
                                } else if (category.categoryName == "Accessories") {
                                    router.push(`/shop/accessories?page=1&title=Accessories&gender=${gender}`);
                                } else if (category.categoryName == "Grooming") {
                                    router.push(`/shop/grooming?page=1&title=Grooming&gender=${gender}`);
                                }
                            }}
                            style={[
                                styles.categoryCard,
                                hoveredIndex === index ? styles.categoryCardHovered : styles.categoryCardNonHovered,
                            ]}
                            onMouseEnter={() => setHoveredIndex(index)}
                            onMouseLeave={() => setHoveredIndex(null)}
                        >
                            <ImageView
                                alt={category?.categoryName}
                                resizeMode={ImageView.resizeMode.cover}
                                source={{
                                    priority: ImageView.priority.high,
                                    uri: category?.imageUrl,
                                }}
                                style={styles.categoryImage}
                            />
                            <VText style={styles.categoryName}>{category?.categoryName}</VText>
                        </Pressable>
                    ))}
            </View>
            {/* </ScrollView> */}
            {currentIndex > 0 && (
                <TouchableOpacity style={[styles.navButton, styles.navButtonLeft]} onPress={() => handleScroll("left")}>
                    <Image accessibilityLabel="Left Arrow" style={styles.navButtonImage} source={Images.left} />
                </TouchableOpacity>
            )}
            {currentIndex < homeCategories.length - 3 && (
                <TouchableOpacity
                    style={[styles.navButton, styles.navButtonRight]}
                    onPress={() => handleScroll("right")}
                >
                    <Image accessibilityLabel="Right Arrow" style={styles.navButtonImage} source={Images.right} />
                </TouchableOpacity>
            )}
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        marginBottom: spV(60),
    },
    headingText: {
        fontFamily: "LibreBodoni",
        textAlign: "left",
        fontSize: fp(32),
        fontWeight: "100",
        color: Colors.black,
        alignSelf: "center",
    },
    navButton: {
        position: "absolute",
        top: "52%",
        borderRadius: 20,
        paddingHorizontal: spH(10),
        paddingVertical: spV(10),
    },
    categoryCard: {
        marginTop: spV(28),
        width: spH(429),
        height: hp(540),
        transition: "all 0.3s ease", // Note: This won't work in React Native, but keeping for reference
    },
    categoryCardHovered: {
        width: wp(790),
        height: hp(540),
        zIndex: 1,
        marginLeft: -spH(100),
        marginRight: -spH(40),
    },
    categoryCardNonHovered: {
        width: wp(429),
        height: hp(540),
        marginHorizontal: 0,
    },
    categoryImage: {
        width: "100%",
        height: "100%",
        backgroundColor: Colors.grey1,
        resizeMode: "cover",
    },
    categoryName: {
        position: "absolute",
        fontFamily: "Libre Bodoni",
        alignSelf: "center",
        color: Colors.white,
        top: "45%",
        fontSize: fp(26),
        fontWeight: "bold",
    },
    navButtonLeft: {
        left: spH(10),
    },
    navButtonRight: {
        right: spH(10),
    },
    navButtonImage: {
        height: spH(30),
        width: spH(30),
    },
});

export default ShopByCategories;
